import type { ComponentProps } from "react";

export const InfoIcon = ({
  color = "#F8F9FA",
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="50" cy="50" r="50" fill={props.fill || "#1C1B26"} />
      <path
        d="M56.8525 76.6395C58.4174 75.6922 59.2375 75.0635 60.6748 73.932L60.8774 68.9949C59.975 69.8973 59.2415 70.4282 59.2415 70.4282C59.2415 70.4282 57.6153 71.6952 56.3747 71.8616C55.2498 72.0125 54.3673 72.1253 53.508 71.3838C52.7473 70.7274 52.5524 68.9949 52.5524 68.9949L53.9858 41.6016H43.1559L42.0411 68.9949C42.0411 68.9949 42.0336 70.4638 42.2003 71.3838C42.4108 72.545 42.6491 73.1848 43.1559 74.2506C43.6968 75.3879 44.024 76.0609 44.9078 76.958C45.6588 77.7203 46.1517 78.1344 47.1375 78.5507C48.1831 78.9921 48.8694 79.01 50.0042 79.0285C51.2619 79.0489 51.9857 78.9153 53.1895 78.5507C54.7337 78.0829 55.4722 77.4751 56.8525 76.6395Z"
        fill="#FFFCFA"
        stroke="#FFFCFA"
        stroke-width="0.318527"
      />
      <circle
        cx="49.2723"
        cy="27.1551"
        r="7.11168"
        fill="#FFFCFA"
        stroke="#FFFCFA"
        stroke-width="0.110353"
      />
    </svg>
  );
};
